import React, { useState, useRef, useEffect } from "react";
import emailjs from "@emailjs/browser";
import "../styles/ContactForm.scss";

function ContactForm() {
  const form = useRef(null);
  const [displayNotification, setDisplayNotification] = useState(false);
  const [displayError, setDisplayError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [name, setName] = useState("Anonymous");
  const [disableSubmitButton, setDisableSubmitButton] = useState(false);

  const sendEmail = (e) => {
    setDisableSubmitButton(true);
    e.preventDefault();
    if (form.current) {
      const emailInput = form.current.elements.namedItem("mail_id");
      const firstName = form.current.elements.namedItem("first_name");
      const lastName = form.current.elements.namedItem("last_name");
      if (firstName.value + lastName.value !== "") {
        setName(firstName.value + " " + lastName.value);
      }
      const email = emailInput.value;
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(email)) {
        setEmailError(true);
        return;
      }
      emailjs
        .sendForm(
          "karuturi's_gmail",
          "template_u42lte1",
          form.current,
          "nswUnlqvc0CrlFt3K"
        )
        .then(
          () => {
            setEmailError(false);
            setDisplayError(false);
            setDisplayNotification(true);
            form.current.reset();
          },
          (error) => {
            setDisplayNotification(false);
            setDisplayError(true);
          }
        );
    }
  };

  useEffect(() => {
    let timeout;
    if (displayNotification) {
      timeout = setTimeout(() => {
        setDisplayNotification(false);
      }, 5000); // Set the timeout to 5 seconds (5000 milliseconds)
    }
    setDisableSubmitButton(false);
    return () => clearTimeout(timeout);
  }, [displayNotification]);

  useEffect(() => {
    let timeout;
    if (displayError) {
      timeout = setTimeout(() => {
        setDisplayError(false);
      }, 5000); // Set the timeout to 5 seconds (5000 milliseconds)
    }
    setDisableSubmitButton(false);
    return () => clearTimeout(timeout);
  }, [displayError]);

  return (
    <>
      <div className="w-full bg-transparent transition-all rounded-2xl">
        <div
          className="flex flex-col h-full bg-transparent transition-all rounded-3xl w-full p-2 project-card"
          style={{ transform: "scale(0.985)" }}
        >
          <div>
            <div className="fixed inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-20 sm:items-end sm:justify-end z-50">
              {/* Notification */}
              <div
                className={`${
                  displayNotification ? "opacity-100" : "opacity-0"
                } transition-opacity duration-1000 ease-in-out bg-white rounded-lg shadow-md p-2 max-w-md w-fit sm:w-auto absolute top-0 m-4`}
              >
                <div className="flex items-center">
                  <div className="ml-3">
                    <p className="text-sm leading-5 font-medium text-gray-900">
                      {name},
                    </p>
                    <p className="mt-1 text-sm leading-5 text-gray-500">
                      Thank you! Your message has been received successfully.
                    </p>
                    <p className="mt-1 text-sm leading-5 text-gray-500">
                      Will get back to you, as soon as possible.
                    </p>
                  </div>
                </div>
              </div>
              {/* Error */}
              <div
                className={`${
                  displayError ? "opacity-100" : "opacity-0"
                } transition-opacity duration-1000 ease-in-out bg-red-700 rounded-lg shadow-md p-2 max-w-md w-fit sm:w-auto absolute top-0 m-4`}
              >
                <div className="flex items-center">
                  <div className="ml-3">
                    <p className="mt-1 text-sm leading-5 text-white">
                      Something went wrong! Please try after sometime.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full absolute md:p-4 flex flex-col">
            <h1 className="text-gray-400 text-3xl dialog comic title w-fit">
              Drop a message :
            </h1>
            <div>
              <form ref={form} onSubmit={sendEmail}>
                <div className="w-full self-center">
                  <div className="flex flex-col gap-y-8 py-4 w-full mt-3">
                    <div className="flex flex-col md:flex-row justify-start space-y-8 md:space-y-0 md:space-x-8">
                      <div className="input_wrap w-full md:w-1/2">
                        <input
                          type="text"
                          className="text-cyan-100 border-2 border-purple-800 px-6 py-4 bg-transparent w-full cus-field"
                          name="first_name"
                          required
                        />
                        <label>First Name*</label>
                      </div>
                      <div className="input_wrap w-full md:w-1/2">
                        <input
                          type="text"
                          className="text-cyan-100 border-2 border-purple-800 px-6 py-4 bg-transparent w-full cus-field"
                          name="last_name"
                          required
                        />
                        <label>Last Name*</label>
                      </div>
                    </div>
                    <div className="input_wrap">
                      <input
                        type="text"
                        className={`text-cyan-100 border-2 border-purple-800 px-6 py-4 bg-transparent w-full cus-field ${
                          emailError ? "border-red-500" : ""
                        }`}
                        name="mail_id"
                        required
                      />
                      <label>Mail ID*</label>
                      {emailError && (
                        <p className="text-red-500">
                          Please enter a valid email address
                        </p>
                      )}
                    </div>
                    <div className="input_wrap">
                      <input
                        type="text"
                        className="text-cyan-100 border-2 border-purple-800 px-6 py-4 bg-transparent w-full cus-field"
                        name="subject"
                        required
                      />
                      <label>Subject Line*</label>
                    </div>
                    <div className="input_wrap">
                      <textarea
                        type="text"
                        className="text-cyan-100 border-2 border-purple-800 px-6 py-4 bg-transparent w-full h-24 cus-field"
                        name="message"
                        required
                      />
                      <label>Message*</label>
                    </div>
                    <div className="flex flex-row cus-btn justify-between items-center">
                      <button
                        type="submit"
                        style={{
                          height: "3em",
                          cursor: disableSubmitButton
                            ? "not-allowed"
                            : "pointer",
                        }}
                        disabled={disableSubmitButton}
                      >
                        SEND
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactForm;
